export default __webpack_public_path__ + "assets/home_background.e2bf18.png";